import { Box } from "@mui/material";
import { TaskerRewardOption } from "@t3/shared";
import { PointsBadge } from "./PointsBadge";
import { GradientRewardBox, RewardText } from "./GradientRewardBox";

interface RewardOptionDisplayProps {
  option: TaskerRewardOption;
  programColor?: string;
}

export const RewardOptionDisplay = ({
  option,
  programColor,
}: RewardOptionDisplayProps) => {
  return (
    <Box
      className="reward-option"
      sx={{
        flex: "1 1 auto",
        minWidth: 0,
        width: "100%",
      }}
    >
      <GradientRewardBox programColor={programColor}>
        <Box
          sx={{
            p: { xs: 1.5, sm: 2 },
            pr: { xs: 10, sm: 11 },
            position: "relative",
          }}
        >
          <PointsBadge amount={option.amount} />
          <Box sx={{ width: "100%" }}>
            <RewardText title={option.label} description={option.description} />
          </Box>
        </Box>
      </GradientRewardBox>
    </Box>
  );
};
